// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".light-theme .ant-layout {\n  background: #fefeff;\n}\n.light-theme .ant-layout-sider-trigger {\n  color: #000;\n  background: #fff;\n  border-right: 1px solid #f0f0f0;\n}\n.light-theme .ant-layout-sider-trigger:hover {\n  color: var(--color-primary);\n}\n.light-theme .ant-layout-sider-collapsed .ant-layout-sider-trigger {\n  color: var(--color-primary);\n  background: var(--primary-light-color);\n}\n", ""]);
// Exports
module.exports = exports;
